module.exports = __webpack_public_path__ + "img/yh.2433fe6c.png";